<template>
	<div>
		<label class="label" @click="select">
			<input class="radio" type="radio"  disabled="disabled" :name="name" :checked="check">
			<span class="radioInput"></span>{{title}}
		</label>
	</div>
</template>
<script>
export default{
	data(){
		return{
			
		}
	},
	methods:{
		select:function(){
			this.$emit('select')
		}
	},
	props: ['title','check','name'],
}
</script>
<style>
	.label {
	    font-size: 14px;
		display: flex;
		align-items: center;
	}
	.radio {
	    display: none
	}
	.radioInput {
	    width: 15px;
	    height: 15px;
	    margin-right: 3px;
	    background-color: #fff;
	    border: 1px solid rgba(0, 0, 0, 0.15);
	    display: inline-block;
	    vertical-align: middle;
	}
	.radio:checked + .radioInput {
	    background-color: #BD8BCA;
	    border-color: #BD8BCA;
	}
</style>